<template lang="pug">
el-container.is-vertical
  el-card.text-center.center(v-if="!isAuthenticated")
    div.clearfix(slot="header")
      div
        img.logo(src="@/assets/logo.svg")
    h2 You are not signed in. Please sign in to continue!
    el-button(@click="login" type="warning") Log In
</template>

<script>
import AuthService from '@/services/AuthService';

export default {
  data() {
    return {
      isAuthenticated: AuthService.isAuthenticated,
    };
  },
  methods: {
    login() {
      AuthService.login();
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-card
  width 300px

  &.center
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)

.logo
  width 200px

h2
  font-weight normal
</style>



// WEBPACK FOOTER //
// src/components/AdminLogin.vue